import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => (
  <nav data-testid="breadcrumbs" className="flex items-center flex-wrap gap-2 text-sm text-vr-dim">
    <Link to="/" className="flex items-center gap-1 hover:text-vr-brand transition-colors">
      <Home size={14} /> Home
    </Link>
    {items.map((it, i) => (
      <span key={i} className="flex items-center gap-2">
        <ChevronRight size={14} className="text-vr-dim/50" />
        {it.to ? (
          <Link to={it.to} className="hover:text-vr-brand transition-colors">{it.label}</Link>
        ) : (
          <span className="text-vr-ink font-medium">{it.label}</span>
        )}
      </span>
    ))}
  </nav>
);
